import { api } from './client';

export type ServiceName = 'jurisapp' | 'autenticador';

export const ALVO_OPTIONS = ['pdpj.portal', 'pdpj.sso', 'pdpj.datalake', 'tribunais'] as const;
export type AlvoName = (typeof ALVO_OPTIONS)[number];

export interface LogEntry {
  timestamp: string;
  level: string;
  event: string;
  logger?: string;
  request_id?: string;
  user_tag?: string;
  client_ip?: string;
  http_method?: string;
  http_path?: string;
  service?: ServiceName;
  alvo?: string;
  operation?: string;
  outcome?: string;
  extra?: Record<string, unknown>;
}

export interface LogQueryResponse {
  entries: LogEntry[];
  total: number;
}

export interface RequestGroup {
  request_id: string;
  method?: string;
  path?: string;
  status?: number;
  duration_ms?: number;
  user_tag?: string;
  service?: ServiceName;
  timestamp?: string;
  log_count: number;
  error_count: number;
  warn_count: number;
}

export interface RequestGroupResponse {
  groups: RequestGroup[];
  total: number;
}

export interface LogQueryParams {
  level?: string;
  event?: string;
  search?: string;
  request_id?: string;
  user_search?: string;
  service?: ServiceName;
  alvo?: string;
  operation?: string;
  start?: string;
  end?: string;
  limit?: number;
}

export async function queryLogs(params: LogQueryParams): Promise<LogQueryResponse> {
  const { data } = await api.get<LogQueryResponse>('/admin/logs', { params });
  return data;
}

export async function queryRequests(params: LogQueryParams): Promise<RequestGroupResponse> {
  const { data } = await api.get<RequestGroupResponse>('/admin/logs/requests', { params });
  return data;
}

export async function resolveUserTags(tags: string[]): Promise<Record<string, string>> {
  const { data } = await api.post<{ resolved: Record<string, string> }>(
    '/admin/users/resolve-tags',
    { tags }
  );
  return data.resolved;
}
